export default __webpack_public_path__ + "static/media/art-center-2.c6e73f5e.jpg";